<h1 mat-dialog-title>{{ 'DELETE-FARM-DIALOG.DELETE-TITLE' | translate }}</h1>
<div mat-dialog-content>
    <p>{{ 'DELETE-FARM-DIALOG.DELETE-FARM' | translate }}</p>
</div>
<div mat-dialog-actions>
    <button class="delete-farm-btn" mat-flat-button (click)="deleteFarm()">{{ 'DELETE-ALL-PINS-DIALOG.YES' | translate }}</button>
    <button  class="delete-farm-btn" mat-flat-button (click)="cancel()">{{ 'DELETE-ALL-PINS-DIALOG.NO' | translate }}</button>
</div>
